import { render, staticRenderFns } from "./PlayerCard.vue?vue&type=template&id=4be77203&"
import script from "./PlayerCard.vue?vue&type=script&lang=js&"
export * from "./PlayerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports